import outdent from "outdent";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gmail = defineConnector({
  identifier: "gmail",
  name: "Gmail",
  tagLine: "Email and contacts",
  logo,
  protocol: "http",
  tags: ["featured", "communication"],
  defaultUrlPattern: () =>
    "https://(gmail\\.googleapis\\.com/.*|www\\.googleapis\\.com/(upload/)?gmail/.*)",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Gmail account",
      items: [
        {
          kind: "markdown",
          content: outdent`
            ⚠️ Currently, Gmail OAuth access is available in limited preview.

            Please reach out to your Tines contact in order to have it enabled for your specific email address. Until then, authorization will be denied.
          `,
        },
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.google.com/o/oauth2/v2/auth",
    tokenEndpoint: () => "https://oauth2.googleapis.com/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "managed",
    scopes: () => ["openid", "email", "profile", "https://mail.google.com/"],
    authorizationParameters: () => ({
      access_type: "offline",
      prompt: "consent",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://gmail.googleapis.com/gmail/v1/users/me/profile",
    }),
  },
});
